/**
 * Global date formatting utility
 * Format: DD MMMM YYYY (e.g., 01 January 2025)
 */

const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

/**
 * Format a date string to DD MMMM YYYY format
 * @param {string} dateStr - Date string in YYYY-MM-DD or ISO format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  } catch {
    return dateStr;
  }
};

/**
 * Format a date string to DD MMM YYYY format (shorter)
 * @param {string} dateStr - Date string in YYYY-MM-DD or ISO format
 * @returns {string} Formatted date string
 */
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNames[date.getMonth()].substring(0, 3);
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  } catch {
    return dateStr;
  }
};

/**
 * Format a date for display with day of week
 * @param {string} dateStr - Date string in YYYY-MM-DD format
 * @returns {string} Formatted date with day of week
 */
export const formatDateWithDay = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;
    
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayOfWeek = dayNames[date.getDay()];
    const day = String(date.getDate()).padStart(2, '0');
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${dayOfWeek}, ${day} ${month} ${year}`;
  } catch {
    return dateStr;
  }
};

export default { formatDate, formatDateShort, formatDateWithDay };
